function MFRGallery(index, element) {
  this.$element = $(element)

  this.selectors = {
    slider: ".slider",
    sliderCounter: ".slider-status",
    sliderItem: ".slider-item",
    gallery: ".section-gallery",
    galleryItem: ".grid-item",
    galleryModal: ".gallery-modal",
    filters: ".filter-item",
    noResults: ".no-results"
  }

  this.states = {
    sliderCounter: 1
  }

  this.init()
}

MFRGallery.prototype = Object.assign({}, MFRGallery.prototype, {
  init: function () {
    this.$gallery = this.$element.find(this.selectors.gallery)
    this.$galleryItem = this.$element.find(this.selectors.galleryItem)
    
    this.$filters = this.$element.find(this.selectors.filters)
    this.$noResults = this.$element.find(this.selectors.noResults)

    this.$slider = $(this.selectors.slider)
    this.$sliderItem = $(this.selectors.sliderItem)
    this.$sliderCounter = $(this.selectors.sliderCounter)
    this.$galleryModal = $(this.selectors.galleryModal)
    
    $(window).on("load", this.__handleInitialization.bind(this))
    $(window).on("resize", this.__handleInitialization.bind(this))

    this.$filters.on("click", this.__handleGalleryFilter.bind(this))
    this.$galleryItem.on("click", this.__handleGallerySlider.bind(this))
  },

  __handleInitialization: function() {
    this.__handleIsotopeInitialization()
    this.__handleGalleryModalChangeSlide()
    this.__handleGalleryModalGoToTop()
    this.__handleGalleryModalOverlayState()
  },

  __handleIsotopeInitialization: function() {
    this.$gallery.isotope({
      itemSelector: '.grid-item',
      percentPosition: true,
      masonry: {
        columnWidth: '.grid-sizer'
      }
    })
  },

  __handleGalleryFilter: function(event) {
    const $currentTarget = $(event.currentTarget)
    const filterValue = $currentTarget.data('filter')
    const resultCount = this.$gallery.data('isotope').filteredItems.length

    this.$gallery.isotope({
      filter: filterValue
    })

    $currentTarget.addClass('is-active').siblings().removeClass('is-active')
    this.__handleGalleryFilterNoResults(resultCount)
  },

  __handleGalleryFilterNoResults: function(results) {
    const $emptyResults = "<p class='no-results'>No matches found.</p>"
    this.$noResults.remove()
    results === 0 ? $($emptyResults).insertAfter(this.$gallery) : this.$noResults.remove()
  },

  __handleGallerySlider: function(event) {
    this.$slider.flickity({
      cellAlign: 'left',
      contain: true,
      pageDots: false,
      setGallerySize: false,
      wrapAround: true,
      on: {
        change: function() {
          const flkty = $(this).get(0)

          flkty.cells.forEach(function(cell, i) {
            const video = cell.element.querySelector("video")

            if (cell.element == flkty.selectedElement) {
              if (video) {
                video.play()
              }
              return
            }

            if (video) {
              video.pause()
            }
          })
        }
      }
    })

    window.flickityButtonArrowChange()

    $('[data-reveal]').on('open.zf.reveal', () => {
      const currentIndex = $(event.currentTarget).data('index') - 1
      
      this.$slider.flickity('resize')
      this.$slider.flickity('select', currentIndex)
      this.__handleGalleryModalCounter()
    })
  },

  __handleGalleryModalChangeSlide: function() {
    this.$slider.on('change.flickity', (event, index) => {
      this.__handleGalleryModalCounter()
    })
  },

  __handleGalleryModalCounter: function() {
    const flickityData = this.$slider.data('flickity')
    const currentNumber = flickityData.selectedIndex + 1
    this.$sliderCounter.text(currentNumber + '/' + flickityData.slides.length)
  },

  __handleGalleryModalOverlayState: function() {
    this.$galleryModal.find(this.$sliderItem).find('img').each(function() {
      $(this).attr('src', $(this).data('src'))
    })

    this.$galleryModal.parent().addClass('dark-overlay')
  },

  __handleGalleryModalGoToTop: function() {
    $('[data-reveal]').on('closed.zf.reveal', () => {
      $('html, body').animate({
        scrollTop: $(document).scrollTop()
      }, 500)
    })
  }
})